
<div>
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>
<div *ngIf="!displayCreateNewLinkedAccount" >

  <div class="row">
    <button id='createNewLinkedAccount' *ngIf='accounts' class="btn btn-primary col-auto ms-2" (click)="createNewLinkedAccount()">Create New Linked Account</button>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <p-table styleClass="p-datatable-striped"  [value]="accounts" [sortOrder]="1" sortField="account.linkedAccountName" [columns]="tableColumn" [scrollable]="true" scrollHeight="50vh">
        <ng-template pTemplate="header" let-columns>
          <tr *ngIf="accounts && accounts.length > 0">
            <ng-container *ngFor="let col of columns">
              <th *ngIf="!col.sort">{{col.header}}</th>
              <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-accountAndUser let-columns="columns">
          <tr>
            <td style="max-width: 50px;" class="noBorder truncate" [pTooltip]="accountAndUser.account.linkedAccountName" tooltipPosition="right" appShowToolTipIfTruncated>
              {{accountAndUser.account.linkedAccountName}}
            </td>
            <td class="noBorder truncate">
              <a class="link" (click)="loginAs(accountAndUser)" id="accountIdLink{{accountAndUser.account.accountId}}">
                {{accountAndUser.account.accountId}}
              </a>
            </td>
            <td class="noBorder truncate">
              {{accountAndUser.account.phone | phoneNumber }}<span *ngIf="accountAndUser.account.phoneExtension">&nbsp; Ext. {{accountAndUser.account.phoneExtension}}</span>
            </td>
            <td class="noBorder truncate">{{accountAndUser.account.email}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <b [translate]="'scr.emptyListNoLinkedAccounts'"></b>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<app-linked-accounts-navigator></app-linked-accounts-navigator>


<div *ngIf="displayCreateNewLinkedAccount">
  <app-linked-accounts-create (emitAction)="receiveChildEvent($event)"></app-linked-accounts-create>
</div>
